<template>
  <div>
    <a-form :label-col="{ span: 5 }" :wrapper-col="{ span: 17 }" :form="form">
      <a-row>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="发布人">
            <a-input v-model="form.is_sue" placeholder="请输入发布人" />
          </a-form-item>
        </a-col>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="话题">
            <a-input v-model="form.label" placeholder="请输入话题" />
          </a-form-item>
        </a-col>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="标题">
            <a-input v-model="form.title" placeholder="请输入标题"></a-input>
          </a-form-item>
        </a-col>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="置顶类型">
            <a-select allowClear v-model="form.top_type" placeholder="请选择置顶类型">
              <a-select-option v-for="item in label.data.POSTS.TOP_TYPE" :key="item.key" :value="item.key" :title="item.value">
                {{ item.value }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="审核状态">
            <a-select v-model="form.check_status" placeholder="请选择审核状态">
              <a-select-option v-for="item in label.data.POSTS.CHECK_STATUS" :key="item.key" :value="item.key" :title="item.value">
                {{ item.value }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="发布时间">
            <a-range-picker v-model="pickDate" />
          </a-form-item>
        </a-col>
        <div style="float:right;">
          <a-button @click="search" type="primary" icon="search" style="margin-right: 20px">查询</a-button>
          <a-button @click="resetCondition" type="primary" icon="delete" ghost>重置</a-button>
        </div>
      </a-row>
    </a-form>
    <!-- <div class="flex-sb">
      <div></div>
      <div>
        <a-button @click="search" type="primary" icon="search" style="margin-right: 10px">查询</a-button>
        <a-button @click="resetCondition" type="primary" icon="delete" ghost>重置</a-button>
      </div>
    </div> -->
    <a-table style="margin-top: 20px" @change="pageChange" :pagination="pagination" :columns="columns" :data-source="dataSource" :loading="loading" rowKey="id">
      <template slot="top_type" slot-scope="text">
        {{ textFormat(text, 'TOP_TYPE') }}
      </template>
      <template slot="is_del" slot-scope="text">
        {{ textFormat(text, 'DEL') }}
      </template>
      <template slot="check_status" slot-scope="text">
        <span style="color: #FE9501;" v-show="parseInt(text) === 0">{{ textFormat(text, 'CHECK_STATUS') }}</span>
        <span style="color: #18BE6B;" v-show="parseInt(text) === 1">{{ textFormat(text, 'CHECK_STATUS') }}</span>
        <span style="color:red;" v-show="parseInt(text) === 2">{{ textFormat(text, 'CHECK_STATUS') }}</span>
      </template>
      <template slot="issue_name" slot-scope="text, record">
        <p style="margin:0;">发布人：{{ `${text}(${record.issue_number})` }}</p>
        <p style="margin:0;">审核人：{{ record.check_name ? record.check_name : '--' }} <span v-show="parseInt(record.check_number)">({{ record.check_number }})</span></p>
      </template>
      <template slot="created_at" slot-scope="text, record">
        <p style="margin:0;">发布时间：{{ text | time }}</p>
        <p style="margin:0;">审核时间：<span v-if=" parseInt(record.check_time)">{{ record.check_time | time }}</span><span v-else>--</span></p>
      </template>
      <template slot="action" slot-scope="text, record">
        <a-button @click="goEdit(record.id)" type="link">编辑</a-button>
        <a-popconfirm title="审核帖子" @confirm="anditArticle(record.id, 1)" @cancel="anditArticle(record.id, 2)" ok-text="通过" cancel-text="驳回">
          <a href="#">审核</a>
        </a-popconfirm>
        <a-dropdown>
          <a-button size="small" type="link" class="ant-dropdown-link" @click="e => e.preventDefault()">
            更多
            <a-icon type="down" />
          </a-button>
          <a-menu slot="overlay">
            <a-menu-item>
              <a-button @click="handelTop(record.id, true)" v-if="record.top_type === '0'" type="link">置顶</a-button>
              <a-button @click="handelTop(record.id, false)" v-else type="link">取消置顶</a-button>
            </a-menu-item>
            <a-menu-item v-if="Number(record.comment)">
              <a-button @click="goComment(record.id)" type="link">评论记录</a-button>
            </a-menu-item>
            <a-menu-item v-if="Number(record.click_like)">
              <a-button @click="goLikeList(record.id)" type="link">点赞记录</a-button>
            </a-menu-item>
            <a-menu-item>
              <a-button @click="handelDel(record.id)" v-if="record.is_del === '0'" type="link">删除</a-button>
              <a-button @click="restoreArt(record.id)" v-else type="link">恢复</a-button>
            </a-menu-item>
          </a-menu>
        </a-dropdown>
      </template>
    </a-table>
  </div>
</template>

<script>
import { columns } from './business/index'
import moment from 'moment'
import { mapState, mapMutations } from 'vuex'
import { artList, checkArt, delArt, restore, topArt, editArt } from '@/api/groupWeb/article'
import _ from 'lodash'
export default {
  computed: {
    ...mapState(['label']),
    ...mapState(['searchForm'])
    // ...mapMutations({})
  },
  watch: {
    pickDate: {
      handler(val) {
        this.form.startTime = val.length ? moment(val[0]).format('YYYY-MM-DD') : ''
        this.form.endTime = val.length ? moment(val[1]).format('YYYY-MM-DD') : ''
      },
      immediate: true
    }
  },
  data() {
    return {
      loading: false,
      columns: columns,
      dataSource: [],
      pickDate: [],
      form: {},
      condition: {},
      top_num: 0,
      pagination: {
        page: 1,
        pageSize: 10,
        total: 0,
        showQuickJumper: true
      }
    }
  },
  filters: {
    time(msg) {
      return (msg = moment(msg * 1000).format('YYYY-MM-DD HH:mm:ss'))
    }
  },
  methods: {
    pageChange(pagination) {
      this.pagination.page = pagination.current
      this.getList()
    },
    async handelTop(id, type) {
      if (type && this.top_num === 2) {
        this.$confirm({
          title: '确认置顶',
          content: '此次置顶会取消其他的置顶帖子，请确认！',
          class: 'isTop',
          okText: '确认',
          cancelText: '取消',
          centered: true,
          onOk: async () => {
            const res = await topArt(id)
            this.doingSuccess(res)
          },
          onCancel() {}
        })
      } else if (type) {
        const res = await topArt(id)
        this.doingSuccess(res)
      } else {
        const params = {
          id,
          top_type: 0
        }
        const res = await editArt(params)
        this.doingSuccess(res)
      }
    },
    async isTop(id, type) {
      const params = {
        id,
        top_type: 0
      }
      const res = await topArt(id)
      this.doingSuccess(res)
    },
    goComment(id) {
      this.$router.push({ path: `/group-web/article/comment`, query: { id } })
    },
    goEdit(id) {
      this.$router.push({
        path: `/group-web/article/detail/${id}`
      })
    },
    goLikeList(id) {
      this.$router.push({
        path: `/group-web/article/like`,
        query: { id }
      })
    },
    doingSuccess(res) {
      if (res.code === '000000') {
        this.$message.success('操作成功')
        this.getList()
      }
    },
    handelDel(id) {
      delArt(id).then(res => this.doingSuccess(res))
    },
    restoreArt(id) {
      restore(id).then(res => this.doingSuccess(res))
    },
    anditArticle(id, check_status) {
      checkArt({ id, check_status }).then(res => this.doingSuccess(res))
    },
    textFormat(text, key) {
      return this.label.data?.POSTS?.[key].find(d => d.key === Number(text))?.value
    },
    onShowSizeChange(current) {
      this.pagination.page = current
      this.getList()
    },
    handelDate(val) {},
    resetCondition() {
      this.pickDate = []
      this.form = {}
      this.condition = {}
      this.search()
    },
    search() {
      this.pagination.page = 1
      this.$store.commit('SET_SEARCH', this.form)
      this.$store.commit('SET_SEARCHDAY', this.pickDate)
      this.condition = _.cloneDeep(this.form)
      this.getList()
    },

    async getList() {
      const params = Object.assign({}, this.condition, {
        page: this.pagination.page,
        per_page: this.pagination.pageSize
      })
      this.loading = true
      try {
        const { data } = await artList(params)
        this.pagination.pageSize = data?.pagination?.per_page || 10
        this.pagination.page = data?.pagination?.page || 1
        this.pagination.total = data?.pagination?.total || 0
        this.dataSource = data?.list
        this.top_num = data.top_num
      } finally {
        this.loading = false
      }
    }
  },
  async mounted() {
    this.form = this.searchForm.data
    this.condition = this.searchForm.data
    this.pickDate = this.searchForm.date
    await this.getList()
  },
  beforeDestroy() {
    if (!this.$route.params.id) {
      this.$store.commit('SET_SEARCH', {})
      this.$store.commit('SET_SEARCHDAY', [])
    }
  }
}
</script>

<style lang="less">
.group-web-artic-list {
  margin-top: 4px;
  .ant-btn {
    padding: 0 4px;
  }
}
.isTop {
  .ant-modal-confirm-btns {
    float: none;
    .ant-btn-primary {
      margin-left: 50px;
    }
  }
  .ant-modal-confirm-body-wrapper {
    text-align: center;
  }
  .anticon svg {
    display: none;
  }
}
</style>
